import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useSearchParams } from "react-router-dom";

const ProtectedRedirectRoute = ({ children }) => {
  const user = useSelector((state) => state.user);
  const [searchParams] = useSearchParams();
  const getRefId = searchParams.get("refId");

  const appendParams = React.useMemo(() => {
    const eventId = searchParams.get("eventId");
    const reportType = searchParams.get("reportType");
    if (!(Number(eventId) > 0) || !["EVENT", "TASK"].includes(reportType))
      return "";
    return `?eventId=${eventId}&reportType=${reportType}${
      !!getRefId ? `&refId=${getRefId}` : ""
    }`;
  }, [getRefId]);

  return user !== null ? (
    children
  ) : (
    <Navigate to={`/login${appendParams}`} replace={true} />
  );
};

export default ProtectedRedirectRoute;
